import { Component, OnInit, inject } from '@angular/core';


import { RegistreService } from '../shared/services/registre.service';

import { CautareComponent } from './cautare/cautare.component';
import { RezultatCmjComponent } from './rezultat-cmj/rezultat-cmj.component';
import { RezultatCmrComponent } from './rezultat-cmr/rezultat-cmr.component';
import { UiStore } from '../shared/state/ui.store';
import { CautareStore } from '../shared/state/cautare.store';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [CautareComponent, RezultatCmjComponent, RezultatCmrComponent]
})
export class DashboardComponent implements OnInit {
    private readonly uiStore = inject(UiStore);
    private regService = inject(RegistreService);

    private readonly cautareStore = inject(CautareStore);

    protected readonly listaCMJ = this.cautareStore.listaCmj;
    protected readonly listaCMR = this.cautareStore.listaCmr;

    constructor() {
        this.uiStore.setAppSection('dashboard');
        this.uiStore.setAppSectionName('Pagină Principală');
        // this.regService.getRegistre();
    }

    ngOnInit() {
        this.uiStore.removeMedicId();
    }

}
